<template>
  <div class="grid-item">
    <div v-if="hdArr.length >= 1" class="onebox">
      <vidobox @delobj='delVedio' :isShowAdd="isShowAdd" id="img1" :url="qing == 1 ? hdArr[0].liveUrl : hdArr[0].liveUrlHd" :list="hdArr[0]" :kbottom="'0px'"
        :width="width" :height="height" :kheight="'40px'" :token="token" />
    </div>
    <div v-if="hdArr.length <= 0" class="onebox">
      <img src="../../assets/image/暂无视频@2x.png" alt="">
      <p>点击
        <span>视频监控列表</span>
        加载视频流
      </p>
    </div>
  </div>
</template>

<script>
var flage = 1
export default {
  props: {
    hdArr: {
      default: []
    },
    qing: {
      default: 1
    },
    token: {
      default: ''
    },
    isShowAdd:{
      default:true,
    }

  },
  data() {
    return {
      width: 0,
      height: 0,
    };
  },
  mounted() {
    this.getBox()
  },

  methods: {
    getBox() {
      let onebox = document.getElementsByClassName('onebox')
      this.width = onebox[0].clientWidth;
      this.height = onebox[0].clientHeight;
      console.log(this.width, this.height, 43);
    },
      delVedio(obj){
        this.$emit('delobj', obj);
      }
  },
}


</script>

<style lang="scss" scoped>
.grid-item {
  color: #fff;
  width: 100%;
  height: 85.5%;
  background: #16385E;
  border-radius: .5rem;

  >div {
    width: 100%;
    height: 100%;
    display: flex;
    background: #16385E;
    border-radius: .5rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 10%;
      margin-bottom: 3%;
    }

    p {
      font-size: 1rem;
      color: #5D7C9E;

      span {
        color: #ffffffa0;
      }
    }
  }
}
</style>